import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuardService} from 'compob2b-auth';
import {CreateUpdateCatalogComponent} from './create-update/create-update-catalog.component';
import {CatalogLazyComponent} from './lazy-tree/catalog-lazy.component';
const routes: Routes = [

  {
    path: '', // path is: cabinet/pim/catalog
    component: CatalogLazyComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: ':catalog_id/features',
        loadChildren: () => import('../catalog-features/catalog-features.module').then(m => m.CatalogFeaturesModule),
        canActivate: [AuthGuardService]
      },
      {
        path: ':catalog_id/ranging',
        loadChildren: () => import('../catalog-ranging/catalog-ranging.module').then(m => m.CatalogRangingModule),
        canActivate: [AuthGuardService]
      },
      {
        path: ':catalog_id/products',
        loadChildren: () => import('../product/product.module').then(m => m.ProductModule),
        canActivate: [AuthGuardService]
      },
      {
        path: '',
        loadChildren: () => import('../product/product.module').then(m => m.ProductModule),
        canActivate: [AuthGuardService]
      },
    ]
  },
  {
    path: 'create', // path is: cabinet/pim/catalog
    component: CreateUpdateCatalogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'create/:parent', // path is: cabinet/pim/catalog
    component: CreateUpdateCatalogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'edit/:id',
    component: CreateUpdateCatalogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'upload',
    loadChildren: () => import('../upload-product-xls/upload-product-xls.module').then(m => m.UploadProductXlsModule),
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogRoutingModule { }
